import { Banner } from '@/components/ui/banner'

/**
 * Amber warning banner about the carrier's current policy renewing soon.
 * Rendered on the results view, above the CTA, to nudge the visitor toward free
 * quotes before renewal. The caller gates on there being an expiration date on
 * file — mirroring the production ConfirmCarrierCard.
 */
export function CurrentInsuranceAlert({
  insurer,
  expirationDate,
}: {
  insurer: string
  /** ISO date (YYYY-MM-DD) from `application.metadata.currentInsurance`. */
  expirationDate: string
}) {
  const expiration = new Date(expirationDate + 'T00:00:00')
  const daysRemaining = Math.ceil((expiration.getTime() - Date.now()) / (1000 * 60 * 60 * 24))

  return (
    <Banner variant="warning">
      <span className="font-semibold">Heads up!</span>{' '}
      {daysRemaining > 0 ? (
        <>
          Your insurance with {insurer} renews in {daysRemaining} {daysRemaining === 1 ? 'day' : 'days'}.
        </>
      ) : (
        <>Your insurance with {insurer} has expired.</>
      )}
    </Banner>
  )
}
